import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { EmvioCard, EmvioRow } from '@nexio/emvio-util-ui';
import { EmvioButton as Button } from '@nexio/emvio-form-components';
import config from '../../config/config';
import './VirtualTerminal.scss';

const RETAIL_TAB_TARGET = 'virtualterminal-retail-tab';

function openRetailInNewTab() {
    const url = config.retailIframeUrl;
    const win = window.open(url, RETAIL_TAB_TARGET);
    if (win) win.location.href = url;
}

export function VirtualTerminal({ location, history }) {
    useEffect(() => {
        if (location?.state?.openVirtualTerminalTab && history) {
            openRetailInNewTab();
            history.replace(location.pathname, {});
        }
    }, [location?.pathname, location?.state?.openVirtualTerminalTab, history]);

    return (
        <EmvioRow className="emvio-virtual-terminal">
            <EmvioCard className="virtual-terminal-card">
                <p>Virtual Terminal has been opened in a new tab.</p>
                <Button
                    className="open-again-button"
                    invertColors={true}
                    onClick={openRetailInNewTab}>
                    Open Again
                </Button>
            </EmvioCard>
        </EmvioRow>
    );
}

export default withRouter(connect()(VirtualTerminal));
